module.exports = __webpack_public_path__ + "static/media/word.407b9ee5.png";